export default {
  name: 'breadcrumb',

  props: {
    breadcrumb: { type: Array /*Array<Object>*/, required: true},
  },
}
